export default __webpack_public_path__ + "static/media/15.a497d3a5.png";